import React, { useState } from 'react';

import { Button } from 'components/Misc/Form';

import Assignment from 'containers/Administrator/Courses/Profile/Students/Assignment';

import { useCourseStudentsStore } from 'store/course/useCourseStudentsStore';

const Bulk = () => {
	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Use student store
	const [data, result, onDeselectAll] = useCourseStudentsStore(state => [
		state.data,
		state.result,
		state.onDeselectAll
	]);

	// Handle modal's visibility toggle
	const onModal = () => setModal(prev => !prev);

	return (
		<div className="px-3 py-3 flex rounded-lg bg-white dark:bg-neutral-800">
			<div className="flex flex-1 items-center space-x-2">
				<div className="text-sm text-neutral-700 dark:text-neutral-500">
					Atlasīti <b>{data.all ? result.total - data.deselected.length : data.selected.length}</b> studenti.
				</div>

				<Button
					value="Noņemt"
					onClick={onDeselectAll}
				/>
			</div>

			<div className="flex items-center">
				<Button
					theme="success"
					value="Rediģēt datumus"
					onClick={onModal}
				/>
			</div>

			<Assignment modal={modal} onModal={onModal} />
		</div>
	);
};

export default Bulk;